var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.827,
    height: 26.436,
    viewBox: "618.462 165.406 19.827 26.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 5",
    transform: "translate(4159 527)",
    clipPath: "url(\"#a\")"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3525.117-335.157-7.711-5.508-7.71 5.508v-20.93c0-.608.493-1.1 1.102-1.1h13.218c.608 0 1.101.492 1.101 1.1v20.93Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#000",
    fill: "transparent",
    "data-name": "Path 25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3536.132-357.188v-3.304c0-.609.493-1.102 1.102-1.102h13.218c.608 0 1.101.493 1.101 1.102v20.928l-4.406-3.146",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#000",
    fill: "transparent",
    "data-name": "Path 26"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0V0z",
    "data-name": "Rectangle 84",
    transform: "translate(-3544 -362)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.d76c68b7637b507e334747f0633b5c3e.svg";
export { ForwardRef as ReactComponent };